export default {
  src: '/images/icons/icons.png',
  spriteInfo: {
    blank: {
      width: 20,
      height: 20,
      x: -20,
      y: 20,
    },
    ok: {
      width: 20,
      height: 20,
      x: 0,
      y: 20,
    },
    walk: {
      width: 20,
      height: 20,
      x: 20,
      y: 20,
    },
    hand: {
      width: 20,
      height: 20,
      x: 40,
      y: 20,
    },
    eye: {
      width: 20,
      height: 20,
      x: 60,
      y: 20,
    },
    talk: {
      width: 20,
      height: 20,
      x: 80,
      y: 20,
    },
    inventory: {
      width: 20,
      height: 20,
      x: 100,
      y: 20,
    },
    settings: {
      width: 20,
      height: 20,
      x: 120,
      y: 20,
    },
    info: {
      width: 20,
      height: 20,
      x: 140,
      y: 20,
    },
    pointer: {
      width: 20,
      height: 20,
      x: 160,
      y: 20,
    },
    money: {
      width: 20,
      height: 20,
      x: 180,
      y: 20,
    },
    pliers: {
      width: 20,
      height: 20,
      x: 200,
      y: 20,
    },
    wait: {
      width: 20,
      height: 20,
      x: 220,
      y: 20,
    },
  }
}
